/** Static brand assets (served from /public/logo). */
export const BRAND_ASSETS = {
  icon: "/logo/logo.png",
  logo: "/logo/logowithtext.png",
  /** Trimmed mark for login/MFA (transparent, no black bar). */
  loginMark: "/logo/login-mark.png",
  favicon: "/logo/favicon.ico",
  favicon32: "/logo/favicon-32x32.png",
  favicon48: "/logo/favicon-48x48.png",
  appleTouchIcon: "/logo/apple-touch-icon.png",
} as const;

export const BRAND_NAME = "Orange";
export const BRAND_ALT = "Orange practice workspace";

/** logowithtext.png / logo.png source dimensions (width ÷ height). */
export const BRAND_LOGO_ASPECT = 3 / 2;
